// extracted by mini-css-extract-plugin
module.exports = {"text":"xmas-promo-banner_text__EUo9U","link":"xmas-promo-banner_link__bB4_S","svg":"xmas-promo-banner_svg__5HVtN"};